import styled from "styled-components";
import {
  COLOR_DEEP_FOREST,
  COLOR_GRAY_GREEN,
  COLOR_MANIFEST_TEAL,
  COLOR_WHITE,
} from "../../styles/globalStylesVariables";
import { tokens } from "@manifesthhqinc/ui-library";

export const CanvasContainer = styled.div<{ $isError?: boolean }>`
  border: 1px solid ${(props) => (props.$isError ? tokens.color.text.error : tokens.color.border.card.default)};
  border-radius: 6px;
  overflow: hidden;
  background-color: ${COLOR_WHITE};
  position: relative;
  width: 100%;
  height: 166px;

  &:hover,
  &:focus-within {
    border-color: ${COLOR_DEEP_FOREST};
  }
`;

export const DottedLineContainer = styled.div`
  position: absolute;
  bottom: 25px;
  left: 25px;
  width: calc(100% - 50px);
  display: flex;
  justify-content: center;
`;

export const DottedLine = styled.div`
  width: 100%;
  height: 2px;
  background-image: linear-gradient(to right, ${COLOR_GRAY_GREEN} 0%, ${COLOR_GRAY_GREEN} 50%, transparent 50%);
  background-size: 4px 2px;
  background-repeat: repeat-x;
`;

export const ClearSignatureButton = styled.button`
display: block;
margin-top: 10px;
text-align: center;
color: ${COLOR_MANIFEST_TEAL};
text-decoration: underline;
cursor: pointer;
background: none;
border: none;
padding: 0;
cursor: pointer;
font-weight: 500;
font-size: 14px

&:hover {
  color: ${COLOR_MANIFEST_TEAL};
}
`;
